/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FrequencyTypeEnum {
    DAY = 'DAY',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    ANNUAL = 'ANNUAL',
}
